var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8421 16C17.3337 16 18.7642 15.4205 19.8189 14.3891C20.8736 13.3576 21.4662 11.9587 21.4662 10.5C21.4662 9.04131 20.8736 7.64236 19.8189 6.61091C18.7642 5.57946 17.3337 5 15.8421 5C14.3505 5 12.92 5.57946 11.8653 6.61091C10.8106 7.64236 10.218 9.04131 10.218 10.5C10.218 11.9587 10.8106 13.3576 11.8653 14.3891C12.92 15.4205 14.3505 16 15.8421 16ZM13.8341 18.0625C9.50625 18.0625 6 21.4914 6 25.7238C6 26.4285 6.58437 27 7.30496 27H24.3792C25.0998 27 25.6842 26.4285 25.6842 25.7238C25.6842 21.4914 22.178 18.0625 17.8501 18.0625H13.8341Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.2dfbecf9a61dd283004c3e7d2aa4dd77.svg";
export { ForwardRef as ReactComponent };